// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"41":"05f7daa8","362":"1c3e6cee","907":"eabc8bf6"}[chunkId] + ".chunk.js";
};